export default {
  ticketPlanes: require('./ticketPlanes.svg'),
  globe: require('./globus.svg'),
  warning: require('./attention.svg'),
  arrow: require('./arrow-down.svg'),
  magnify: require('./search.svg'),
  xIcon: require('./close.svg'),
  phoneCall: require('./call-phone.svg'),
  extendedSurfPackage: require('./extendedPackage.svg'),
  okDone: require('./ok-done.svg'),
  smiley1: require('./smiley1.svg'),
  smiley2: require('./smiley2.svg'),
  smiley3: require('./smiley3.svg'),
  smiley4: require('./smiley4.svg'),
  smiley5: require('./smiley5.svg'),
};
